var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 70,
    viewBox: "0 0 58 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 2,
    transform: "rotate(-90 7 7)",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 69,
    width: 68,
    height: 56,
    rx: 4,
    transform: "rotate(-90 1 69)",
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3613 30.5234C38.2188 30.6359 35.7031 32.0785 35.7031 35.2863C35.7031 38.9967 38.9042 40.3093 39 40.3418C38.9853 40.4218 38.4915 42.1395 37.3122 43.8897C36.2608 45.4298 35.1626 46.9675 33.4921 46.9675C31.8215 46.9675 31.3916 45.9799 29.4631 45.9799C27.5837 45.9799 26.9155 47 25.3874 47C23.8594 47 22.7931 45.5749 21.5673 43.8247C20.1473 41.7695 19 38.5767 19 35.5464C19 30.6859 22.1053 28.1081 25.1614 28.1081C26.7853 28.1081 28.1389 29.1932 29.1585 29.1932C30.1289 29.1932 31.6422 28.0431 33.4896 28.0431C34.1898 28.0431 36.7054 28.1081 38.3613 30.5234ZM32.6126 25.9854C33.3766 25.0628 33.9171 23.7827 33.9171 22.5026C33.9171 22.325 33.9023 22.145 33.8704 22C32.6273 22.0475 31.1484 22.8426 30.2566 23.8952C29.5564 24.7053 28.903 25.9854 28.903 27.283C28.903 27.478 28.9349 27.6731 28.9496 27.7356C29.0283 27.7506 29.156 27.7681 29.2837 27.7681C30.3991 27.7681 31.8019 27.008 32.6126 25.9854Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/ios-icon.db6c2aad1f4dd7d218b319bc8eec7c4f.svg";
export { ForwardRef as ReactComponent };